import { Controller } from "@hotwired/stimulus"

// Wires a file input and a URL input to a single <img> preview. Whichever the
// operator interacts with last wins. File picks use object URLs (revoked on
// the next swap so we don't leak); URL picks are best-effort with onerror.
export default class extends Controller {
  static targets = ["image", "placeholder"]

  connect() {
    this._objectUrl = null
    this._urlDebounce = null
  }

  disconnect() {
    this.revokeObjectUrl()
    if (this._urlDebounce) clearTimeout(this._urlDebounce)
  }

  fromFile(event) {
    const file = event.currentTarget.files && event.currentTarget.files[0]
    if (!file) return
    this.revokeObjectUrl()
    this._objectUrl = URL.createObjectURL(file)
    this.show(this._objectUrl)
  }

  fromUrl(event) {
    this.applyUrl(event.currentTarget.value)
  }

  fromUrlDebounced(event) {
    if (this._urlDebounce) clearTimeout(this._urlDebounce)
    const value = event.currentTarget.value
    this._urlDebounce = setTimeout(() => this.applyUrl(value), 400)
  }

  applyUrl(url) {
    if (!url || !/^https?:\/\//i.test(url)) {
      // empty or non-http: only hide if we don't have a file preview already
      if (!this._objectUrl) this.hide()
      return
    }
    this.revokeObjectUrl()
    this.show(url)
  }

  show(src) {
    if (!this.hasImageTarget) return
    this.imageTarget.onerror = () => this.hide()
    this.imageTarget.src = src
    this.imageTarget.hidden = false
    if (this.hasPlaceholderTarget) this.placeholderTarget.hidden = true
  }

  hide() {
    if (this.hasImageTarget) {
      this.imageTarget.hidden = true
      this.imageTarget.removeAttribute("src")
    }
    if (this.hasPlaceholderTarget) this.placeholderTarget.hidden = false
  }

  revokeObjectUrl() {
    if (this._objectUrl) {
      URL.revokeObjectURL(this._objectUrl)
      this._objectUrl = null
    }
  }
}
